__turbopack_context__.v({
  "checkbox": "oSwJeG_checkbox",
  "checkbox--lg": "oSwJeG_checkbox--lg",
  "checkbox--md": "oSwJeG_checkbox--md",
  "checkbox--sm": "oSwJeG_checkbox--sm",
  "checkboxContainer": "oSwJeG_checkboxContainer",
  "checkedState": "oSwJeG_checkedState",
  "indeterminateState": "oSwJeG_indeterminateState",
  "label": "oSwJeG_label",
});
